import React from "react";

import { Link } from "react-router-dom";
import { Box, Card, Chip, type ChipProps, Link as MUILink, Stack, Typography } from "@mui/material";

type Props = {
  title: string;
  status: string;
  date: string;
  url: string;
  chipColor: ChipProps["color"];
};

const ActionCard: React.FC<Props> = ({ title, status, date, url, chipColor }) => {
  const localDate = new Date(date).toLocaleDateString(navigator.language, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return (
    <Card>
      <Box sx={{ p: 2, pr: 1 }}>
        <Box sx={{ display: "flex" }}>
          <Stack spacing={1} sx={{ flexGrow: 1 }}>
            <MUILink variant="body2" component={Link} to={url}>
              {title}
            </MUILink>
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Typography color="textSecondary" sx={{ fontSize: "12px" }}>
                {localDate}
              </Typography>
              <Chip variant="status" label={status} color={chipColor} />
            </Box>
          </Stack>
        </Box>
      </Box>
    </Card>
  );
};

export default ActionCard;
